import axios from 'axios';

export const apiZoho = axios.create({
  baseURL: 'https://zoho.accsolutions.tech/API/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});
